module.exports = __webpack_public_path__ + "img/assets/logo-milanowski--symbol.20fdce86a219f0d79554b45dac8bf909.svg";